import antLocale from 'antd/lib/locale/vi_VN';
import translations from './translations.json';

export default {
  name: 'Tiếng Việt',
  translations,
  antLocale,
};
